<template>
  <div class="card">
    <div class="card-body pt-1" v-if="hasVisibleFiles">
      <div class="files-header d-flex align-items-center">
        <div class="d-flex" style="width: 100%; height: 100%">
          <div class="header d-flex align-items-center" style="width: 80%;" @click="changeSort('name')">
            <span class="ml-2 mr-1">File name</span>
            <div>
              <font-awesome-icon :icon="'caret-up'"
                                 :color="sortBy.key === 'name' && sortBy.desc ? '#63c2de' : '#d1d4d7'"></font-awesome-icon>
              <font-awesome-icon :icon="'caret-down'"
                                 :color="sortBy.key === 'name' && !sortBy.desc ? '#63c2de' : '#d1d4d7'"></font-awesome-icon>
            </div>
          </div>
          <div class="header d-flex justify-content-center align-items-center" style="width: 10%"
               @click="changeSort('type')">
            <span class="mr-1">Extension</span>
            <div>
              <font-awesome-icon :icon="'caret-up'"
                                 :color="sortBy.key === 'type' && sortBy.desc ? '#63c2de' : '#d1d4d7'"></font-awesome-icon>
              <font-awesome-icon :icon="'caret-down'"
                                 :color="sortBy.key === 'type' && !sortBy.desc ? '#63c2de' : '#d1d4d7'"></font-awesome-icon>
            </div>
          </div>
        </div>
      </div>
      <div class="file-list">
        <div v-for="(f, index) in filteredData" class="file d-flex justify-content-between"
             :class="{secondary: index%2 === 0}" :key="`category-${index}`">
          <div class="d-flex align-items-center" style="width: 80%">
            <span class="ml-2">{{f.name}}</span>
          </div>
          <div class="d-flex justify-content-center align-items-center" style="width: 10%">
            {{f.type}}
          </div>
          <div class="download d-flex justify-content-center align-items-center" style="width: 10%"
               @click.prevent="download(f)">
            <font-awesome-icon icon="download" class="mr-1"></font-awesome-icon>
            Download
          </div>
        </div>
      </div>
      <div class="file-categories d-flex justify-content-end mt-3">
        <div v-for="(fileCount, category) in parsedFileData.categories"
             class="file-type ml-3 d-flex justify-content-center align-items-center"
             @click="selectedCategory = category" :key="category">
          <div class="d-flex align-items-center">
            <input type="radio" class="mr-1 m-b-1" v-model="selectedCategory" :value="category" :id="category"/>
            {{category}} <span class="m-l-2" style="font-size: 90%; color: lightgrey">({{fileCount}})</span>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body" v-else>
      <div class="d-flex justify-content-center align-items-center my-3">
        <span>No files detected</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import studyActions from '../../store/modules/studies/actionTypes'

export default {
  name: 'RelatedFilesList',
  props: {
    data: Array
  },
  data () {
    return {
      parsedFileData: {
        categories: {},
        files: []
      },
      selectedCategory: '',
      hiddenExtensions: ['feather', 'json'],
      sortBy: {
        key: 'name',
        desc: true
      },
      showRDF: false
    }
  },
  computed: {
    hasVisibleFiles () {
      return this.parsedFileData.files.length > 0
    },
    filteredData () {
      const filteredObj = this.parsedFileData.files.filter(el => el.category === this.selectedCategory)
      const sortedObj = Object.keys(filteredObj).sort((a, b) => {
        if (filteredObj[a] < filteredObj[b]) {
          return -1
        }
        if (filteredObj[a] > filteredObj[b]) {
          return 1
        }
        return 0
      }).map(key => filteredObj[key])
      return this.sortBy.desc ? sortedObj : sortedObj.reverse()
    }
  },
  watch: {
    data (next) {
      if (Array.isArray(next) && next.length) {
        this.parseFiles(next)
      } else {
        this.parsedFileData = { categories: {}, files: [] }
        this.selectedCategory = ''
      }
    }
  },
  methods: {
    ...mapActions({
      getStudyFile: studyActions.FETCH_FILE
    }),
    fileExtension (fileName) {
      const parts = String(fileName || '').split('.')
      return parts.length > 1 ? parts.pop().toLowerCase() : ''
    },
    fileBaseName (fileName) {
      const parts = String(fileName || '').split('.')
      if (parts.length <= 1) {
        return fileName
      }
      parts.pop()
      return parts.join('.')
    },
    parseFiles (filesData) {
      this.parsedFileData = { categories: {}, files: [] }
      filesData.forEach(category => {
        if (category.category !== 'RDFs' || this.showRDF) {
          let visibleCount = 0
          category.files.forEach(file => {
            const fileName = file.file
            const extension = this.fileExtension(fileName)
            if (this.hiddenExtensions.includes(extension)) {
              return
            }
            visibleCount += 1
            this.parsedFileData.files.push({
              name: this.fileBaseName(fileName),
              type: extension,
              id: file.id,
              category: category.category
            })
          })
          if (visibleCount > 0) {
            this.parsedFileData.categories[category.category] = visibleCount
          }
        }
      })
      const obj = this.parsedFileData.categories
      Object.keys(obj).sort((a, b) => obj[a] < obj[b] ? -1 : obj[a] > obj[b] ? 1 : 0).map(key => obj[key])
      this.selectedCategory = Object.keys(this.parsedFileData.categories)[0] || ''
    },
    async download (f) {
      const response = await this.getStudyFile({ studyId: this.$route.params.id, fileId: f.id })
      const url = window.URL.createObjectURL(new Blob([response]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${f.name}.${f.type}`)
      document.body.appendChild(link)
      link.click()
    },
    changeSort (newKey) {
      if (this.sortBy.key === newKey) {
        const test = !this.sortBy.desc
        this.$set(this.sortBy, 'desc', test)
      } else {
        this.$set(this.sortBy, 'key', newKey)
        this.$set(this.sortBy, 'desc', true)
      }
    }
  },

  mounted () {
    this.showRDF = this.$auth.user().permissions.isAdmin || this.$auth.user().permissions.allowDownload
    this.parseFiles(this.data)
  }
}
</script>

<style lang="scss" scoped>

.card {
  background-color: #F9FAFB;
}

.files-header {
  margin-top: 10px;
  height: 40px;
  border-bottom: 1px solid #d1d4d7;
}

.file-type {
  cursor: pointer;
  font-size: 15px;
}

.file {
  height: 40px;
  transition: 0.1s background-color linear;
}

.file:hover {
  background-color: #F5F7FA !important;
}

.file-list {
  max-height: 400px;
  overflow-y: scroll;
}

.header {
  height: 100%;
  transition: 0.1s background-color linear;
}

.header:hover {
  background-color: #f6f6f6;
}

.secondary {
  background-color: rgb(245, 247, 255);
}

.category {
  border: 1px solid #20a8d8;
  padding: 1px 3px 0;
  font-size: 85%;
  transition: 0.1s color linear;
}

.file-type:hover .category {
  color: #20a8d8;
}

.badge {
  font-size: 85%;
  padding-top: 4px;
}

.selected-category {
  font-weight: bold;
  border: 1px solid #20a8d8;
  background-color: #20a8d8;
  padding: 1px 3px 0;
  color: white;
  font-size: 85%;
}

.download {
  cursor: pointer;
  transition: 0.1s color linear;
}

.download:hover {
  color: #20a8d8;
}
</style>

<style lang="scss">
@import "../../assets/scss/variables";

.table-striped {
  thead {
    th {
      border-bottom: 0 !important;
      border-color: #E2E2E3 !important;
      color: #202124 !important;
      font-family: 'Open Sans', sans-serif;
      font-weight: 900;
      font-size: 14px;
      text-transform: uppercase;
      text-align: center;
    }
  }

  tbody {
    tr {

      &:nth-of-type(odd) {
        background-color: #FAFAFB !important;
      }

      &:hover {
        background-color: #f3f3f4 !important;
      }

      td {
        border-color: #E2E2E3 !important;
        font-family: 'Open Sans', sans-serif;
        font-size: 14px;
        color: #000000CC;
        text-align: center;
      }
    }
  }
}

.VuePagination {
  nav {
    display: flex;

    .VuePagination__count {
      line-height: 35px;
      text-align: left !important;
      color: $pewter !important;
      font-family: 'Source Sans Pro', sans-serif;
      font-weight: 400;
      font-size: 14px;
    }

    .page-item {
      font-family: 'Source Sans Pro', sans-serif;
      font-weight: 400;
      font-size: 13px;
      margin: 0 4px;

      a {
        color: rgba(77, 79, 92, 0.51) !important;
        border: 1px solid #E8E9EC !important;
        border-radius: 4px !important;
      }
    }

    .active {
      a {
        background-color: #e4e5e6 !important;
      }
    }
  }
}
</style>
